const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const associationSlug = process.env.REACT_APP_ASSOCIATION_SLUG;
//REACT_APP_API_BASE_URL=https://core.dev.kiido.app/collaboration-api
//add association slugs 

export const fetchLocationsApi = async (url = null, limit = 10, offset = 0) => {
  const requestUrl = url ? url : `${BASE_URL}/${associationSlug}/location/?limit=${limit}&offset=${offset}`;
  // console.log(requestUrl);

  const response = await fetch(requestUrl);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const data = await response.json();
  return data;
};

export const fetchLocationsByDepartmentApi = async (url = null, department = 75, limit = 10, offset = 0) => {
  const requestUrl = url ? url : `${BASE_URL}/${associationSlug}/location/?departments=${department}&limit=${limit}&offset=${offset}`;
  // console.log(requestUrl);

  const response = await fetch(requestUrl);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const data = await response.json();
  return data;
};

export const fetchServicesApi = async (url = null, limit = 10, offset = 0) => {
  const requestUrl = url ? url : `${BASE_URL}/${associationSlug}/service/?limit=${limit}&offset=${offset}`;
  // console.log(requestUrl, associationSlug);

  const response = await fetch(requestUrl);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const data = await response.json();
  return data;
};

export const fetchAvailabilityApi = async (fromDate, toDate, locationId, serviceId, sessionsTypeStored, thespecialist) => {
  let URL;
  // Start building the base URL
  if (locationId === null) {
    URL = `${BASE_URL}/${associationSlug}/avaibility/?from=${fromDate}&to=${toDate}&location=&service=${serviceId}&is_location_agnostic=true`;
  } else {
    URL = `${BASE_URL}/${associationSlug}/avaibility/?from=${fromDate}&to=${toDate}&location=${locationId}&service=${serviceId}`;
  }

  // Conditionally add 'service_provider_slug' if 'thespecialist' is available
  if (thespecialist) {
    URL += `&service_provider_slug=${thespecialist}`;
  }

  // Fetch data from the constructed URL
  const response = await fetch(URL);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  const data = await response.json();
  // console.log(data);
  return data;
};



export const fetchNearLocationsApi = async (latitude, longitude, limit = 10, offset = 0) => {
  // console.log(latitude, longitude, limit, offset)
  // log the url
  // console.log(`${BASE_URL}/${associationSlug}/location/?lat=${latitude}&lon=${longitude}&limit=${limit}&offset=${offset}`)
  const response = await fetch(`${BASE_URL}/${associationSlug}/location/?lat=${latitude}&lon=${longitude}&limit=${limit}&offset=${offset}`);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const data = await response.json();
  // console.log(data);
  return data;
}

export const submitBookingApi = async (bookingData) => {
  //  console.log(JSON.stringify(bookingData));
  const response = await fetch(`${BASE_URL}/rdv/create/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bookingData),
  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const data = await response.json();
  return data;
};

export const fetchCollaboratorDetailsApi = async (slug) => {
  const URL = `${BASE_URL}/collaborator/details/${slug}`;

  // Fetch data from the API
  const response = await fetch(URL);
  if (!response.ok) {
    throw response;
  }

  const data = await response.json();
  return data;
};

export const fetchFileNumberValidation = async ({ value, slotNumber }) => {
  const URL = `${BASE_URL}/participant/file-number/${value}?tentative_avb_slot=${slotNumber}`;

  // Fetch data from the API
  const response = await fetch(URL);
  if (!response.ok) {
    throw response;
  }

  const data = await response.json();
  return data;
};


